export const lateGreen700 = `#2B495A`;
